"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOrderLineVersion = exports.createOrderLineVersions = exports.deleteOrderById = exports.createOrderLine = exports.deleteOrderLineById = exports.deleteOrderNoteById = exports.togglePinOrderNoteById = exports.getOrderEmailsByOrderId = exports.getOrderLineChangeRequestsByOrderLineId = exports.getOrderLinkedLineById = exports.getOrderLinkedLinesById = exports.getOrderNotesByOrderLineId = exports.getOrderNoteById = exports.getOrderLineById = exports.getOrderLineVersionById = exports.getClientOrders = exports.updateVariantConfig = exports.createVariant = exports.getOrderTransactionsByOrderId = exports.getClientTransactions = exports.getOrderTransactionOwnersByOrderId = exports.getRawOrderById = exports.getOrderById = exports.addOrderNote = exports.createOrder = exports.setDefaultVariant = exports.getOrderLogsByOrderId = exports.getOrderNotesByOrderId = exports.getOrderLineReminders = exports.getOrderRemindersByOrderId = exports.updateOrder = exports.getVariantById = exports.getOrders = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const _ = require("lodash");
const uuid_1 = require("uuid");
const dayjs = require("dayjs");
const utilities_1 = require("../utilities");
const getOrderVariantById_1 = require("../utilities/orders/getOrderVariantById");
const getOrders = async (supabase) => {
    const { data, error } = await supabase.from("orders").select(`
  *,
  client:user_profiles!client_id(*),
  agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*)),
  order_lines!id(*, 
    versions:order_line_versions!order_line_id(
      *,
      regions(id, name, slug, country_id)
    )
  ),  
  transactions(*, transaction_items(*)),
  created_by_user:created_by(id, first_name, last_name)
  `);
    if (!error)
        return data;
    return error;
};
exports.getOrders = getOrders;
const getVariantById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_variants")
        .select(`*,
        order_lines!id(*,         
          reminders(*),
          versions:order_line_versions!order_line_id(
            *,
            regions(id, name, slug),
            order_lines!linked_line_id(*, 
              versions:order_line_versions!order_line_id
              (*)
            )
          )
        )`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return null;
};
exports.getVariantById = getVariantById;
const updateOrder = async (supabase, obj) => {
    const order = _.cloneDeep(obj);
    delete order.client;
    delete order.created_by_user;
    delete order.assigned_to_user;
    delete order.transactions;
    delete order.order_lines;
    delete order.reminders;
    delete order.reference;
    delete order.agent;
    delete order.quotes;
    const { data, error } = await supabase
        .from("orders")
        .upsert([order])
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateOrder = updateOrder;
const getOrderRemindersByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("reminders")
        .select(`*,
      orders(reference),
      order_lines(*, 
        versions:order_line_versions!order_line_id(
          *,
          regions(id, name, slug, country_id)
        )
      ),    
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("order_id", id);
    if (!error)
        return data;
    return error;
};
exports.getOrderRemindersByOrderId = getOrderRemindersByOrderId;
const getOrderLineReminders = async (supabase, id) => {
    const { data, error } = await supabase
        .from("reminders")
        .select("*")
        .eq("order_line_id", id);
    if (!error)
        return data;
    return error;
};
exports.getOrderLineReminders = getOrderLineReminders;
const getOrderNotesByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_notes")
        .select("*, client:user_profiles!created_by(*)")
        .eq("order_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getOrderNotesByOrderId = getOrderNotesByOrderId;
const getOrderLogsByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_log")
        .select("* ,created_by_user:created_by(id, first_name, last_name)")
        .eq("order_id", id)
        .order("created_at", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getOrderLogsByOrderId = getOrderLogsByOrderId;
const setDefaultVariant = async (supabase, orderId, variantId) => {
    const { data, error } = await supabase
        .from("orders")
        .update({ default_variant_id: variantId })
        .eq("id", orderId);
    if (!error) {
        return data;
    }
};
exports.setDefaultVariant = setDefaultVariant;
const createOrder = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.created_by = user?.id;
    if (!obj.assigned_to)
        obj.assigned_to = user?.id;
    obj.created_at = new Date();
    const { data, error } = await supabase
        .from("orders")
        .insert([obj])
        .select()
        .single();
    if (!error) {
        // create default variant
        const createVariantResult = await (0, exports.createVariant)(supabase, data.id, "Default Variant");
        await (0, exports.setDefaultVariant)(supabase, data.id, createVariantResult.id);
        const order = await (0, exports.getOrderById)(supabase, data.id);
        await (0, utilities_1.addOrderLog)(supabase, {
            type: "ORDER",
            order_id: order.id,
            detail: {
                type: "Order Created",
                status: "DRAFT",
                total: null,
                title: `${order.reference}`,
                message: `Manual Order Created - ${order.source}`,
            },
        });
        return {
            data: order,
            error: null,
        };
    }
    return {
        data: null,
        error: error,
    };
};
exports.createOrder = createOrder;
const addOrderNote = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.created_by = user?.id;
    const { data, error } = await supabase.from("order_notes").insert([obj]);
    if (!error)
        return data;
    return error;
};
exports.addOrderNote = addOrderNote;
const getOrderById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("orders")
        .select(`  *,
      client:user_profiles!client_id(*),      
      variants:order_variants!order_id(*,
        order_lines!id(*,         
          reminders(*),
          versions:order_line_versions!order_line_id(
            *,
            regions(id, name, slug, weekend_days),
            order_lines!linked_line_id(*, 
              versions:order_line_versions!order_line_id
              (*)
            )
          )
        )
      ), 
      transactions(*, transaction_items(*)),
      created_by_user:created_by(id, first_name, last_name)`)
        .is("variants.order_lines.versions.linked_line_id", null)
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getOrderById = getOrderById;
const getRawOrderById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("orders")
        .select(`*,
      reminders(*),
      quotes:quotes!order_id(*,
      created_by_user:created_by(id, first_name, last_name),
      accepted_by_user:accepted_by(id, first_name, last_name)
      ),
      client:user_profiles!client_id(*, orders!orders_client_id_fkey(count)),
      agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*)),
      variants:order_variants!order_id(*,
        order_lines!id(*,         
          reminders(*),
          versions:order_line_versions!order_line_id(
            *,
            regions(id, name, slug, country_id),
            order_lines!linked_line_id(*, 
              versions:order_line_versions!order_line_id
              (*)
            )
          )
        )
      ), 
      transactions(*, transaction_items(*)),
      created_by_user:created_by(id, first_name, last_name),
      assigned_to_user:assigned_to(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getRawOrderById = getRawOrderById;
const getOrderTransactionOwnersByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_lines")
        .select("*, versions:order_line_versions!order_line_id(*)")
        .eq("order_id", id);
    if (!error) {
        // for each data get the suppliers.id
        const suppliers = data.map((item) => {
            if (item.versions === undefined)
                return null;
            const latest_version = (0, utilities_1.getLatestOrderLineVersion)(item.versions);
            const config = latest_version?.config;
            return {
                id: config.supplier.id,
                name: config.supplier.name,
                type: "supplier",
            };
        });
        // remove duplicates
        const uniqueSuppliers = suppliers.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
        // sort by name
        uniqueSuppliers.sort((a, b) => (a.name > b.name ? 1 : -1));
        return uniqueSuppliers;
    }
    return error;
};
exports.getOrderTransactionOwnersByOrderId = getOrderTransactionOwnersByOrderId;
const getClientTransactions = async (supabase, id) => {
    const { data, error } = await supabase.rpc("get_transactions_by_name_id", {
        n_id: id,
    });
    if (!error)
        return data;
    return error;
};
exports.getClientTransactions = getClientTransactions;
const getOrderTransactionsByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("transactions")
        .select(`*, 
      order:orders!id(reference),
      transaction_items(
        *, 
        account:finance_accounts(id, name, account_ref, currency), 
        order:orders!id(reference),
        customer:user_profiles!user_id(id, first_name, last_name, email), 
        supplier:suppliers(*)
      )`)
        .eq("order_id", id);
    if (!error)
        return data;
    return error;
};
exports.getOrderTransactionsByOrderId = getOrderTransactionsByOrderId;
const createVariant = async (supabase, orderId, name) => {
    const { data, error } = await supabase
        .from("order_variants")
        .insert({ order_id: orderId, name: name })
        .select("*, order_lines(*)")
        .single();
    if (!error)
        return data;
    return error;
};
exports.createVariant = createVariant;
const updateVariantConfig = async (supabase, variantId, obj) => {
    const { data, error } = await supabase
        .from("order_variants")
        .update({
        config: obj,
    })
        .eq("id", variantId)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateVariantConfig = updateVariantConfig;
const getClientOrders = async (supabase, id) => {
    const { data, error } = await supabase
        .from("orders")
        .select(`*, 
      client:user_profiles!client_id(*), 
      order_lines!id(*, 
        versions:order_line_versions!order_line_id(
          *,
          regions(id, name, slug, country_id),
          order_lines!linked_line_id(*, 
            versions:order_line_versions!order_line_id
            (*)
          )
        )
      ),
      created_by_user:created_by(id, first_name, last_name)`)
        .is("order_lines.versions.linked_line_id", null)
        .eq("client_id", id);
    if (!error)
        return data;
    return error;
};
exports.getClientOrders = getClientOrders;
const getOrderLineVersionById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_line_versions")
        .select("*")
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getOrderLineVersionById = getOrderLineVersionById;
const getOrderLineById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_lines")
        .select("*,  versions:order_line_versions!order_line_id(*, created_by_user:created_by(id, first_name, last_name), regions(id, name, slug, country_id))")
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getOrderLineById = getOrderLineById;
const getOrderNoteById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_notes")
        .select("*, client:user_profiles!created_by(*)")
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getOrderNoteById = getOrderNoteById;
const getOrderNotesByOrderLineId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_notes")
        .select("*, client:user_profiles!created_by(*)")
        .eq("order_item_id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getOrderNotesByOrderLineId = getOrderNotesByOrderLineId;
const getOrderLinkedLinesById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_lines")
        .select("*, versions:order_line_versions!order_line_id!inner(*, regions(id, name, slug, country_id))")
        .eq("versions.linked_line_id", id);
    if (!error)
        return data;
    return error;
};
exports.getOrderLinkedLinesById = getOrderLinkedLinesById;
const getOrderLinkedLineById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_lines")
        .select("*, versions:order_line_versions!order_line_id!inner(*, regions(id, name, slug, country_id))")
        .eq("versions.linked_line_id", id)
        .single();
    if (!error)
        return {
            ...data,
        };
    return error;
};
exports.getOrderLinkedLineById = getOrderLinkedLineById;
const getOrderLineChangeRequestsByOrderLineId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_notes")
        .select("*, client:user_profiles!created_by(*)")
        .eq("order_item_id", id)
        .eq("type", "CHANGE_REQUEST")
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getOrderLineChangeRequestsByOrderLineId = getOrderLineChangeRequestsByOrderLineId;
const getOrderEmailsByOrderId = async (supabase, id) => {
    const { data, error } = await supabase
        .from("email_log")
        .select(`*,
      template:email_templates!id(*),
      agent:agent_accounts!agent_id(*, agent_config:agent_configurations!agent_config_id(*)),
      client:user_profiles!client_id(*),
      supplier:suppliers!id(*),
      events:email_log_events!id(*)`)
        .eq("order_id", id)
        .order("created_at", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getOrderEmailsByOrderId = getOrderEmailsByOrderId;
const togglePinOrderNoteById = async (supabase, id, pinned) => {
    const { data, error } = await supabase
        .from("order_notes")
        .update({ pinned: pinned })
        .eq("id", id);
    if (!error) {
        return data;
    }
};
exports.togglePinOrderNoteById = togglePinOrderNoteById;
const deleteOrderNoteById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("order_notes")
        .delete()
        .eq("id", id);
    if (!error) {
        return data;
    }
};
exports.deleteOrderNoteById = deleteOrderNoteById;
const deleteOrderLineById = async (supabase, id) => {
    const order_line = await (0, exports.getOrderLineById)(supabase, id);
    const { data, error } = await supabase
        .from("order_lines")
        .delete()
        .eq("id", id);
    if (!error) {
        const o = order_line;
        if (o?.order_id) {
            if (!o)
                return null;
            if (o.versions === undefined)
                return null;
            const latest_version = (0, utilities_1.getLatestOrderLineVersion)(o.versions);
            if (latest_version && o) {
                const desc = (0, utilities_1.getOrderLineDescriptions)(o);
                await (0, utilities_1.addOrderLog)(supabase, {
                    type: o.type,
                    order_id: o.order_id,
                    detail: {
                        type: "Line Deleted",
                        status: latest_version.status,
                        title: `${(0, utilities_1.getOrderLineTitle)(o)} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`,
                        message: `${desc && desc.join("<br/>")}`,
                    },
                });
            }
        }
        return data;
    }
};
exports.deleteOrderLineById = deleteOrderLineById;
const createOrderLine = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    const order_line = _.cloneDeep(obj);
    if (obj.versions === undefined)
        return null;
    const order_version = obj.versions[0];
    order_version.created_by = user?.id;
    delete obj.versions;
    const { data, error } = await supabase.from("order_lines").insert([obj]);
    const { data: version_data, error: version_error } = await supabase
        .from("order_line_versions")
        .insert([order_version]);
    if (!error && !version_error) {
        const line = order_line;
        const latest_version = (0, utilities_1.getLatestOrderLineVersion)([order_version]);
        if (latest_version) {
            const desc = (0, utilities_1.getOrderLineDescriptions)(line);
            await (0, utilities_1.addOrderLog)(supabase, {
                type: line.type,
                order_id: line.order_id,
                detail: {
                    type: "Line Created",
                    status: latest_version.status,
                    title: `${(0, utilities_1.getOrderLineTitle)(line)}`,
                    total: (0, utilities_1.currencyFormatter)((0, utilities_1.getOrderLineCurrency)(line) || "", (0, utilities_1.getOrderLineTotal)(line), false),
                    message: `${desc && desc.join("<br/>")}`,
                },
            });
        }
        return { data, version_data };
    }
    return error;
};
exports.createOrderLine = createOrderLine;
const deleteOrderById = async (supabase, id) => {
    const { data, error } = await supabase.from("orders").delete().eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteOrderById = deleteOrderById;
const createOrderLineVersions = async (supabase, objs) => {
    const { data: { user }, } = await supabase.auth.getUser();
    const objs_arry = _.cloneDeep(objs);
    for (const obj of objs_arry) {
        delete obj.regions;
        delete obj.created_by_user;
        delete obj.order_lines;
        obj.created_by = user?.id;
        obj.created_at = new Date();
        obj.id = (0, uuid_1.v4)();
    }
    const { data, error } = await supabase
        .from("order_line_versions")
        .insert(objs_arry);
    if (error)
        return {
            success: false,
            error: error,
        };
    return {
        success: true,
    };
};
exports.createOrderLineVersions = createOrderLineVersions;
const createOrderLineVersion = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    delete obj.regions;
    // get order_line
    const order_line = await (0, exports.getOrderLineById)(supabase, obj.order_line_id);
    if (order_line === undefined) {
        return null;
    }
    const ol = order_line;
    const order = (await (0, exports.getOrderById)(supabase, ol.order_id));
    const variant = (await (0, getOrderVariantById_1.getOrderVariantById)(supabase, ol.order_variant_id));
    if (variant?.country_id === null || order?.country_id === null) {
        // get the region of the order_line
        const region = await (0, utilities_1.getRegion)(supabase, obj?.region_id);
        if (variant?.country_id === null) {
            variant.country_id = region?.country_id;
            await (0, utilities_1.updateVariant)(supabase, variant);
        }
        if (order.country_id === null) {
            order.country_id = region?.country_id;
            await (0, exports.updateOrder)(supabase, order);
        }
    }
    delete obj.created_by_user;
    obj.created_by = user?.id;
    obj.created_at = new Date();
    obj.id = (0, uuid_1.v4)();
    const { data, error } = await supabase
        .from("order_line_versions")
        .insert([obj]);
    if (!error) {
        if (order_line === undefined) {
            console.log("Order Line not found");
        }
        else {
            const line = order_line;
            line.versions?.push(obj);
            const latest_version = obj;
            const desc = (0, utilities_1.getOrderLineDescriptions)(line);
            await (0, utilities_1.addOrderLog)(supabase, {
                type: line.type,
                order_id: line.order_id,
                detail: {
                    type: "Line Edit",
                    status: latest_version.status,
                    title: `${(0, utilities_1.getOrderLineTitle)(line)} - ${dayjs(latest_version?.start_date).format("DD MMM [‘]YY")}`,
                    total: (0, utilities_1.currencyFormatter)((0, utilities_1.getOrderLineCurrency)(line) || "", (0, utilities_1.getOrderLineTotal)(line), false),
                    message: `${desc && desc.join("<br/>")}`,
                },
            });
        }
        return data;
    }
    return error;
};
exports.createOrderLineVersion = createOrderLineVersion;
